<script>
  import Carregando from '~componentes/Carregando.vue';
  import pessoaFisicaServico from '../servico';

  export default {
    components: {
      Carregando
    },
    data() {
      return {
        carregando: true,

        assinaturasDisponiveis: [],
        paginaAberto: 1,
        totalPaginasAberto: 1,
        filtroAberto: {
          nomeArquivo: '',
          tipoDocumento: '',
          papelAssinatura: '',
          dataCriacaoInicio: '',
          dataCriacaoFim: '',
        },
        erroFiltroAberto: '',

        assinaturasFinalizadas: [],
        paginaFinalizadas: 1,
        totalPaginasFinalizadas: 1,
        carregandoFinalizadas: false,
        finalizadasJaCarregadas: false,
        filtroFinalizadas: {
          nomeArquivo: '',
          tipoDocumento: '',
          papelAssinatura: '',
          status: '',
          dataCriacaoInicio: '',
          dataCriacaoFim: '',
          dataAssinaturaInicio: '',
          dataAssinaturaFim: '',
        },
        erroFiltroFinalizadas: '',
        abaAtual: 'aberto',
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Assinatura Eletrônica';

      this.carregar();
    },
    methods: {
      carregar() {
        const estado = this.restaurarEstadoDaUrl();

        this.buscarAssinaturas(estado.paginaAberto, true);

        if (estado.aba === 'finalizadas') {
          this.abaAtual = 'finalizadas';
          this.buscarAssinaturas(estado.paginaFinalizadas, false);

          this.$nextTick(() => {
            $('a[href="#tab-finalizadas"]').tab('show');
          });
        }
      },

      buscarAssinaturas(pagina, emAberto) {
        if (emAberto) {
          this.carregando = true;
        } else {
          this.carregandoFinalizadas = true;
        }

        const filtro = emAberto ? this.filtroAberto : this.filtroFinalizadas;

        return pessoaFisicaServico
          .buscarAssinaturasFiltrada(pagina, emAberto, filtro)
          .then(dados => {
            if (emAberto) {
              this.assinaturasDisponiveis = dados.registros || [];
              this.paginaAberto = dados.pagina;
              this.totalPaginasAberto = dados.totalPaginas;
            } else {
              this.assinaturasFinalizadas = dados.registros || [];
              this.paginaFinalizadas = dados.pagina;
              this.totalPaginasFinalizadas = dados.totalPaginas;
              this.finalizadasJaCarregadas = true;
            }
          })
          .finally(() => {
            if (emAberto) {
              this.carregando = false;
            } else {
              this.carregandoFinalizadas = false;
            }
          });
      },

      dataInicioMaiorQueFim(inicio, fim) {
        if (!inicio || !fim) {
          return false;
        }
        return new Date(inicio) > new Date(fim);
      },

      aplicarFiltroAberto() {
        this.erroFiltroAberto = '';

        if (this.dataInicioMaiorQueFim(this.filtroAberto.dataCriacaoInicio, this.filtroAberto.dataCriacaoFim)) {
          this.erroFiltroAberto = 'A data de início da criação não pode ser maior que a data de fim.';
          return;
        }

        this.buscarAssinaturas(1, true);
      },

      aplicarFiltroFinalizadas() {
        this.erroFiltroFinalizadas = '';

        if (this.dataInicioMaiorQueFim(this.filtroFinalizadas.dataCriacaoInicio, this.filtroFinalizadas.dataCriacaoFim)) {
          this.erroFiltroFinalizadas = 'A data de início da criação não pode ser maior que a data de fim.';
          return;
        }

        if (this.dataInicioMaiorQueFim(this.filtroFinalizadas.dataAssinaturaInicio, this.filtroFinalizadas.dataAssinaturaFim)) {
          this.erroFiltroFinalizadas = 'A data de início da assinatura não pode ser maior que a data de fim.';
          return;
        }

        this.buscarAssinaturas(1, false);
      },

      onCliqueAbaFinalizadas() {
        if (this.finalizadasJaCarregadas) {
          return;
        }

        this.buscarAssinaturas(1, false);
      },

      irParaPaginaAberto(pagina) {
        if (this.totalPaginasAberto <= 1) return;

        if (pagina < 1) {
          pagina = this.totalPaginasAberto; 
        } else if (pagina > this.totalPaginasAberto) {
          pagina = 1; 
        }

        this.buscarAssinaturas(pagina, true);
      },

      irParaPaginaFinalizadas(pagina) {
        if (this.totalPaginasFinalizadas <= 1) return;

        if (pagina < 1) {
          pagina = this.totalPaginasFinalizadas;
        } else if (pagina > this.totalPaginasFinalizadas) {
          pagina = 1;
        }

        this.buscarAssinaturas(pagina, false);
      },

      limparFiltroAberto() {
        this.erroFiltroAberto = '';
        this.filtroAberto = {
          nomeArquivo: '',
          tipoDocumento: '',
          papelAssinatura: '',
          dataCriacaoInicio: '',
          dataCriacaoFim: '',
        };
        this.buscarAssinaturas(1, true);
      },

      limparFiltroFinalizadas() {
        this.erroFiltroFinalizadas = '';
        this.filtroFinalizadas = {
          nomeArquivo: '',
          tipoDocumento: '',
          papelAssinatura: '',
          status: '',
          dataCriacaoInicio: '',
          dataCriacaoFim: '',
          dataAssinaturaInicio: '',
          dataAssinaturaFim: '',
        };
        this.buscarAssinaturas(1, false);
      },

      podeAssinar(item) {
        if (!this.ehGestao) {
          return true;
        }

        return item.podeAssinarGestao === true;
      },
      downloadArquivoAssinatura(documento, assinatura) {
        return pessoaFisicaServico.downloadArquivoAssinatura(assinatura.idDocumentoAssinaturaAssinante, documento.nomeArquivo).then(
          arquivo => { arquivo.download() }
        )
      },
      assinarDocumento(documento) {
        this.$router.push({
          name: `${this.prefixoRota}.assinar`,
          params: { id: documento.idDocumentoAssinaturaAssinante },
          query: this.montarQuery(),
        });
      },
      verDetalhesDocumento(documento) {
        this.$router.push({
          name: `${this.prefixoRota}.detalhes`,
          params: { id: documento.idDocumentoAssinaturaAssinante },
          query: this.montarQuery(),
        });
      },
      montarQuery() {
        const query = {};

        Object.keys(this.filtroAberto).forEach(chave => {
          if (this.filtroAberto[chave]) query['a_' + chave] = this.filtroAberto[chave];
        });

        Object.keys(this.filtroFinalizadas).forEach(chave => {
          if (this.filtroFinalizadas[chave]) query['f_' + chave] = this.filtroFinalizadas[chave];
        });

        if (this.paginaAberto > 1) query.pa = this.paginaAberto;
        if (this.paginaFinalizadas > 1) query.pf = this.paginaFinalizadas;
        if (this.abaAtual === 'finalizadas') query.aba = 'finalizadas';

        return query;
      },

      salvarEstadoNaUrl() {
        const resultado = this.$router.replace({
          name: this.$route.name,
          params: this.$route.params,
          query: this.montarQuery(),
        });

        if (resultado && resultado.catch) resultado.catch(() => { });
      },

      restaurarEstadoDaUrl() {
        const q = this.$route.query || {};

        Object.keys(this.filtroAberto).forEach(chave => {
          if (q['a_' + chave]) this.filtroAberto[chave] = q['a_' + chave];
        });

        Object.keys(this.filtroFinalizadas).forEach(chave => {
          if (q['f_' + chave]) this.filtroFinalizadas[chave] = q['f_' + chave];
        });

        return {
          paginaAberto: parseInt(q.pa, 10) || 1,
          paginaFinalizadas: parseInt(q.pf, 10) || 1,
          aba: q.aba === 'finalizadas' ? 'finalizadas' : 'aberto',
        };
      },
    },
    computed: {
      prefixoRota() {
        return (this.$route.meta && this.$route.meta.prefixoRotaAssinatura) || 'pessoa-fisica.assinatura';
      },
      ehGestao() {
        return this.prefixoRota === 'assinatura-embed'
      },

      assinaturasDisponiveisFiltradas() {
        return this.assinaturasDisponiveis;
      },

      assinaturasFinalizadasFiltradas() {
        return this.assinaturasFinalizadas;
      },
    }
  }
</script>

<template>
  <div>

    <form @submit.prevent="">

      <carregando v-if="carregando"></carregando>

      <div class="tabs-container" v-show="!carregando" id="tabs">

        <ul class="nav nav-tabs">
          <li class="active">
           <a data-toggle="tab" href="#tab-em-aberto" @click="abaAtual = 'aberto'">Em aberto</a>
          </li>
          <li>
           <a data-toggle="tab" href="#tab-finalizadas"
              @click="abaAtual = 'finalizadas'; onCliqueAbaFinalizadas()">Finalizadas</a>
          </li>
        </ul>

        <div class="tab-content">
          <div id="tab-em-aberto" class="tab-pane active">
            <div class="panel-body">
              <h1>Em aberto</h1>

              <div class="row">
                <div class="col-xs-3">
                  <div class="form-group">
                    <label class="control-label">Nome do arquivo</label>
                    <input type="text" class="form-control" v-model="filtroAberto.nomeArquivo" placeholder="Buscar..."
                           @keyup.enter="aplicarFiltroAberto">
                  </div>
                </div>
                <div class="col-xs-2">
                  <div class="form-group">
                    <label class="control-label">Tipo do documento</label>
                    <input type="text" class="form-control" v-model="filtroAberto.tipoDocumento" placeholder="Buscar..."
                           @keyup.enter="aplicarFiltroAberto">
                  </div>
                </div>
                <div class="col-xs-2" v-if="!ehGestao">
                  <div class="form-group">
                    <label class="control-label">Papel do assinante</label>
                    <input type="text" class="form-control" v-model="filtroAberto.papelAssinatura" placeholder="Buscar..."
                           @keyup.enter="aplicarFiltroAberto">
                  </div>
                </div>
                <div class="col-xs-2">
                  <div class="form-group">
                    <label class="control-label">Data criação (início)</label>
                    <input type="date" class="form-control" v-model="filtroAberto.dataCriacaoInicio">
                  </div>
                </div>
                <div class="col-xs-2">
                  <div class="form-group">
                    <label class="control-label">Data criação (fim)</label>
                    <input type="date" class="form-control" v-model="filtroAberto.dataCriacaoFim">
                  </div>
                </div>
              </div>

              <div class="row" v-if="erroFiltroAberto">
                <div class="col-xs-12">
                  <div class="alert alert-warning" role="alert">
                    <i class="fa fa-exclamation-triangle"></i> {{ erroFiltroAberto }}
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-12 text-right">
                  <button type="button" class="btn btn-default" @click="limparFiltroAberto">
                    <i class="fa fa-eraser"></i> Limpar filtros
                  </button>
                  <button type="button" class="btn btn-primary" @click="aplicarFiltroAberto">
                    <i class="fa fa-filter"></i> Aplicar filtro
                  </button>
                </div>
              </div>

              <div class="table-responsive" style="padding-top: 20px;">
                <table class="table relatorio table-bordered">
                  <thead>
                    <tr>
                      <th>Nome do Arquivo</th>
                      <th>Tipo do Arquivo</th>
                      <th v-if="!ehGestao">Papel do Assinante</th>
                      <th>Data de Criação do Documento</th>
                      <th>{{ ehGestao ? 'Status do Documento' : 'Status da Assinatura' }}</th>
                      <th class="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in assinaturasDisponiveisFiltradas" :key="item.idDocumentoAssinaturaAssinante">
                      <td>{{ item.documentoAssinatura.nomeArquivo }}</td>
                      <td>{{ item.documentoAssinatura.tipoDocumento }}</td>
                      <td v-if="!ehGestao">{{ item.papelAssinatura }}</td>
                      <td>
                        {{ item.documentoAssinatura.dataHoraCriacao | formatarData }} - {{
                        item.documentoAssinatura.dataHoraCriacao | formatarHora
                        }}
                      </td>
                      <td>{{ ehGestao ? item.documentoAssinatura.statusDocumento : item.statusAssinatura }}</td>
                      <td class="text-center">
                        <button type="button" class="btn btn-success btn-xs" v-tooltip="'Baixar arquivo'"
                                @click="downloadArquivoAssinatura(item.documentoAssinatura, item)">
                          <i class="fa fa-download"></i>
                        </button>
                        <button type="button" class="btn btn-primary btn-xs" v-tooltip="'Ver detalhes'"
                                @click="verDetalhesDocumento(item)">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-if="podeAssinar(item)" type="button" class="btn btn-info btn-xs" v-tooltip="'Assinar documento'"
                                @click="assinarDocumento(item)">
                          <i class="fa fa-pencil"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="assinaturasDisponiveisFiltradas.length === 0">
                      <td :colspan="ehGestao ? 5 : 6" class="text-center">Nenhum documento disponível para assinatura.</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <ul class="pagination" v-if="totalPaginasAberto > 1">
                <li>
                  <a href="#" @click.prevent="irParaPaginaAberto(paginaAberto - 1)">&laquo;</a>
                </li>
                <li class="disabled"><a href="#" @click.prevent>{{ paginaAberto }} / {{ totalPaginasAberto }}</a></li>
                <li>
                  <a href="#" @click.prevent="irParaPaginaAberto(paginaAberto + 1)">&raquo;</a>
                </li>
              </ul>
            </div>
          </div>

          <div id="tab-finalizadas" class="tab-pane">
            <div class="panel-body">
              <h1>Finalizadas</h1>

              <div class="row">
                <div class="col-xs-2">
                  <div class="form-group">
                    <label class="control-label">Nome do arquivo</label>
                    <input type="text" class="form-control" v-model="filtroFinalizadas.nomeArquivo" placeholder="Buscar..."
                           @keyup.enter="aplicarFiltroFinalizadas">
                  </div>
                </div>
                <div class="col-xs-2">
                  <div class="form-group">
                    <label class="control-label">Tipo do arquivo</label>
                    <input type="text" class="form-control" v-model="filtroFinalizadas.tipoDocumento" placeholder="Buscar..."
                           @keyup.enter="aplicarFiltroFinalizadas">
                  </div>
                </div>
                <div class="col-xs-2" v-if="!ehGestao">
                  <div class="form-group">
                    <label class="control-label">Papel do assinante</label>
                    <input type="text" class="form-control" v-model="filtroFinalizadas.papelAssinatura" placeholder="Buscar..."
                           @keyup.enter="aplicarFiltroFinalizadas">
                  </div>
                </div>
                <div class="col-xs-2">
                  <div class="form-group">
                    <label class="control-label">Status</label>
                    <select class="form-control" v-model="filtroFinalizadas.status">
                      <option value="">Todos</option>
                      <option value="CONCLUIDO">Concluído</option>
                      <option value="CANCELADO">Cancelado</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-3">
                  <div class="form-group">
                    <label class="control-label">Data criação (início)</label>
                    <input type="date" class="form-control" v-model="filtroFinalizadas.dataCriacaoInicio">
                  </div>
                </div>
                <div class="col-xs-3">
                  <div class="form-group">
                    <label class="control-label">Data criação (fim)</label>
                    <input type="date" class="form-control" v-model="filtroFinalizadas.dataCriacaoFim">
                  </div>
                </div>
                <div class="col-xs-3">
                  <div class="form-group">
                    <label class="control-label">Data assinatura (início)</label>
                    <input type="date" class="form-control" v-model="filtroFinalizadas.dataAssinaturaInicio">
                  </div>
                </div>
                <div class="col-xs-3">
                  <div class="form-group">
                    <label class="control-label">Data assinatura (fim)</label>
                    <input type="date" class="form-control" v-model="filtroFinalizadas.dataAssinaturaFim">
                  </div>
                </div>
              </div>

              <div class="row" v-if="erroFiltroFinalizadas">
                <div class="col-xs-12">
                  <div class="alert alert-warning" role="alert">
                    <i class="fa fa-exclamation-triangle"></i> {{ erroFiltroFinalizadas }}
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-12 text-right">
                  <button type="button" class="btn btn-default" @click="limparFiltroFinalizadas">
                    <i class="fa fa-eraser"></i> Limpar filtros
                  </button>
                  <button type="button" class="btn btn-primary" @click="aplicarFiltroFinalizadas">
                    <i class="fa fa-filter"></i> Aplicar filtro
                  </button>
                </div>
              </div>

              <carregando v-if="carregandoFinalizadas"></carregando>

              <div v-else class="table-responsive" style="padding-top: 20px;">
                <table class="table relatorio table-bordered">
                  <thead>
                    <tr>
                      <th>Nome do Arquivo</th>
                      <th>Tipo do Arquivo</th>
                      <th v-if="!ehGestao">Papel do Assinante</th>
                      <th>Data de Criação do Documento</th>
                      <th>{{ ehGestao ? 'Status do Documento' : 'Status da Assinatura' }}</th>
                      <th>Data da Assinatura</th>
                      <th class="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in assinaturasFinalizadasFiltradas"
                        :key="item.idDocumentoAssinaturaAssinante">
                      <td>{{ item.documentoAssinatura.nomeArquivo }}</td>
                      <td>{{ item.documentoAssinatura.tipoDocumento }}</td>
                      <td v-if="!ehGestao">{{ item.papelAssinatura }}</td>
                      <td>
                        {{ item.documentoAssinatura.dataHoraCriacao | formatarData }} - {{
                        item.documentoAssinatura.dataHoraCriacao | formatarHora
                        }}
                      </td>
                      <td>{{ ehGestao ? item.documentoAssinatura.statusDocumento : item.statusAssinatura }}</td>
                      <td>
                        {{ item.dataHoraAssinatura | formatarData }} - {{
                        item.dataHoraAssinatura | formatarHora
                        }}
                      </td>
                      <td class="text-center">
                        <button type="button" class="btn btn-success btn-xs" v-tooltip="'Baixar arquivo'"
                                @click="downloadArquivoAssinatura(item.documentoAssinatura, item)">
                          <i class="fa fa-download"></i>
                        </button>
                        <button type="button" class="btn btn-primary btn-xs" v-tooltip="'Ver detalhes'"
                                @click="verDetalhesDocumento(item)">
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="assinaturasFinalizadasFiltradas.length === 0">
                      <td :colspan="ehGestao ? 6 : 7" class="text-center">Nenhum documento finalizado foi encontrado.</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <ul class="pagination" v-if="totalPaginasFinalizadas > 1">
                <li>
                  <a href="#" @click.prevent="irParaPaginaFinalizadas(paginaFinalizadas - 1)">&laquo;</a>
                </li>
                <li class="disabled"><a href="#" @click.prevent>{{ paginaFinalizadas }} / {{ totalPaginasFinalizadas }}</a></li>
                <li>
                  <a href="#" @click.prevent="irParaPaginaFinalizadas(paginaFinalizadas + 1)">&raquo;</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </form>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/pessoa-fisica/componentes/Assinatura.vue